<template>
  <div class="property-details-display">
    <div class="row mb-3">
      <div class="col-sm-12">
        <div class="toolbar text-right">
          <dropdown 
            :dropUp="false"
            :title="'Property Actions'"
            :icon="'fa fa-building'"
            :actions="propertyActions"
            @action="executeAction($event, property)">
          </dropdown>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="card mb-5">
          <h4 class="card-header">
            <i class="fa fa-fw fa-building"></i> Property Details
          </h4>
          <div class="card-body">
            <img :src="'https://maps.googleapis.com/maps/api/streetview?size=600x200&location=' + property.address +'&key=AIzaSyChsNbsujgDDgecCVkJNUkG2WFntMXPZ4c'" class="img-fluid mb-3">
            <responsive-table
              :hideColumns="true"
              :collapse="false">
              <template slot="rows">
                <tr>
                  <td>
                    <strong>Address</strong>
                  </td>
                  <td>{{ property.address }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Building Name</strong>
                  </td>
                  <td>{{ property.buildingName }}</td>
                </tr>
                <tr v-if="!$route.meta.client">
                  <td>
                    <strong>Company</strong>
                  </td>
                  <td>
                    <router-link 
                      v-if="property.Company"
                      :to="'/database-manager/companies/' + property.Company.uuid">
                      {{ property.Company.name }}
                    </router-link>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Suburb</strong>
                  </td>
                  <td>{{ property.suburb }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Postcode</strong>
                  </td>
                  <td>{{ property.postcode }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Lots</strong>
                  </td>
                  <td>{{ property.lots }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Strata Plan Number</strong>
                  </td>
                  <td>{{ property.strataPlanNumber }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Plan Of Subdivision</strong>
                  </td>
                  <td>
                    <download-input
                      v-if="property.PlanOfSubdivision" 
                      :options="{ label: property.planOfSubdivisionNumber, permalink: 'downloadFile'}"
                      :value="{ objectKey: property.PlanOfSubdivision.objectKey }" />
                    <span v-else>
                      {{ property.planOfSubdivisionNumber }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Insurance Company</strong>
                  </td>
                  <td>{{ property.insuranceCompany }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Access Instructions</strong>
                  </td>
                  <td>{{ property.accessInstructions }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Building Insurance</strong>
                  </td>
                  <td>{{ property.buildingInsurance }}</td>
                </tr>
              </template>
            </responsive-table>
            <img :src="staticMap" class="img-fluid">
            <br /><br />
            <accordian-display
              v-if="property.hasAltAddress"
              class="mt-1"
              :defaultOpen="false"
              :title="'Alternate Address'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Details</strong>
                    </td>
                    <td>{{ property.altAddress }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasKeySafe"
              class="mt-1"
              :defaultOpen="false"
              :title="'Alternate Address'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Details</strong>
                    </td>
                    <td>{{ property.keySafe }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasESMserviceContract"
              class="mt-1"
              :defaultOpen="false"
              :title="'ESM service contract'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Company Name</strong>
                    </td>
                    <td>{{ property.ESMserviceContractCPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Phone Number</strong>
                    </td>
                    <td>{{ property.ESMserviceContractPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>A/H Phone Number</strong>
                    </td>
                    <td>{{ property.ESMserviceContractEPN }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasEmbeddedServices"
              class="mt-1"
              :defaultOpen="false"
              :title="'Embedded Services'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Company Name</strong>
                    </td>
                    <td>{{ property.embeddedServicesCPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Phone Number</strong>
                    </td>
                    <td>{{ property.embeddedServicesPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>A/H Phone Number</strong>
                    </td>
                    <td>{{ property.embeddedServicesEPN }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasElectricityContract"
              class="mt-1"
              :defaultOpen="false"
              :title="'Electricity service contract'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Company Name</strong>
                    </td>
                    <td>{{ property.electricityContractCPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Phone Number</strong>
                    </td>
                    <td>{{ property.electricityContractPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>A/H Phone Number</strong>
                    </td>
                    <td>{{ property.electricityContractEPN }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasHotWaterContract"
              class="mt-1"
              :defaultOpen="false"
              :title="'Hot water service contract'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Company Name</strong>
                    </td>
                    <td>{{ property.hotWaterContractCPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Phone Number</strong>
                    </td>
                    <td>{{ property.hotWaterContractPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>A/H Phone Number</strong>
                    </td>
                    <td>{{ property.hotWaterContractEPN }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasLiftContract"
              class="mt-1"
              :defaultOpen="false"
              :title="'Lift Service Contract'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Company Name</strong>
                    </td>
                    <td>{{ property.liftContractCPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Phone Number</strong>
                    </td>
                    <td>{{ property.liftContractPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>A/H Phone Number</strong>
                    </td>
                    <td>{{ property.liftContractEPN }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasGarageDoorContract"
              class="mt-1"
              :defaultOpen="false"
              :title="'Garage door Service Contract'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Company Name</strong>
                    </td>
                    <td>{{ property.garageDoorContractCPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Phone Number</strong>
                    </td>
                    <td>{{ property.garageDoorContractPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>A/H Phone Number</strong>
                    </td>
                    <td>{{ property.garageDoorContractEPN }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasAccessControlContract"
              class="mt-1"
              :defaultOpen="false"
              :title="'Access Control Contract'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Company Name</strong>
                    </td>
                    <td>{{ property.accessControlContractCPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Phone Number</strong>
                    </td>
                    <td>{{ property.accessControlContractPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>A/H Phone Number</strong>
                    </td>
                    <td>{{ property.accessControlContractEPN }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasAccessDoorContract"
              class="mt-1"
              :defaultOpen="false"
              :title="'Access Door Service Contract'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Company Name</strong>
                    </td>
                    <td>{{ property.accessDoorContractCPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Phone Number</strong>
                    </td>
                    <td>{{ property.accessDoorContractPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>A/H Phone Number</strong>
                    </td>
                    <td>{{ property.accessDoorContractEPN }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasVentilationContract"
              class="mt-1"
              :defaultOpen="false"
              :title="'Common Area Ventilation Service Contract'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Company Name</strong>
                    </td>
                    <td>{{ property.ventilationContractCPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Phone Number</strong>
                    </td>
                    <td>{{ property.ventilationContractPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>A/H Phone Number</strong>
                    </td>
                    <td>{{ property.ventilationContractEPN }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasCleaningContract"
              class="mt-1"
              :defaultOpen="false"
              :title="'Cleaning Service Contract'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Company Name</strong>
                    </td>
                    <td>{{ property.cleaningContractCPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Phone Number</strong>
                    </td>
                    <td>{{ property.cleaningContractPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>A/H Phone Number</strong>
                    </td>
                    <td>{{ property.cleaningContractEPN }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasFacilityManager"
              class="mt-1"
              :defaultOpen="false"
              :title="'Facility Manager'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Company Name</strong>
                    </td>
                    <td>{{ property.facilityManagerCPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Phone Number</strong>
                    </td>
                    <td>{{ property.facilityManagerPN }}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>A/H Phone Number</strong>
                    </td>
                    <td>{{ property.facilityManagerEPN }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasBuildersWarranty"
              class="mt-1"
              :defaultOpen="false"
              :title="'Builders Warranty'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Details</strong>
                    </td>
                    <td>{{ property.buildersWarranty }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
            <accordian-display
              v-if="property.hasCommittee"
              class="mt-1"
              :defaultOpen="false"
              :title="'Building Committee'"
              :icon="'far fa-fw fa-file'">
              <responsive-table
                :hideColumns="true"
                :collapse="false">
                <template slot="rows">
                  <tr>
                    <td>
                      <strong>Details</strong>
                    </td>
                    <td>{{ property.committee }}</td>
                  </tr>
                </template>
              </responsive-table>
            </accordian-display>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <nav-tabs>
          <tab name="Notes" icon="fa fa-sticky-note">
            <div class="text-right mb-3">
              <button class="btn btn-success" @click="executeAction('addPropertyNote', property)">
                <i class="fa fa-plus"></i> New Note
              </button>
            </div>
            <search-form
              ref="propertyNotesSearchForm"
              :results="propertyNotes"
              :total-results="propertyNotesTotal"
              :options="notesForm">
            </search-form>
          </tab>
          <!-- Photos -->
          <tab name="Photos" icon="fa fa-images">
            <div class="text-right mb-3">
              <button class="btn btn-success" @click="executeAction('uploadPropertyPhoto', property)">
                <i class="fa fa-upload"></i> Upload Photo
              </button>
            </div>
            <search-form
              ref="propertyPhotosSearchForm"
              :results="propertyPhotos"
              :total-results="propertyPhotosTotal"
              :options="photosForm">
            </search-form>
          </tab>
          <!-- Preferred Contractors -->
          <tab v-if="!$route.meta.client" name="Preferred Contractors" icon="fa fa-wrench">
            <div class="text-right mb-3">
              <button class="btn btn-success" @click="executeAction('newPropertyContractor', property)">
                <i class="fa fa-plus"></i> New Contractor
              </button>
            </div>
            <search-form
              ref="propertyContractorsSearchForm"
              :results="propertyContractors"
              :tableDisplay="true"
              :columns="propertyContractorsColumns"
              :total-results="propertyContractorsTotal"
              :options="contractorsForm">
            </search-form>
          </tab>
        </nav-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  import Dropdown from '@/components/ui/Dropdown'
  import DownloadInput from '@/components/inputs/DownloadInput'
  import NavTabs from '@/components/ui/NavTab'
  import Tab from '@/components/ui/Tab'
  import SearchForm from '@/components/SearchForm'
  import ResponsiveTable from '@/components/ui/ResponsiveTable'
  import AccordianDisplay from '@/components/displays/AccordianDisplay'
  import {
    SET_PROPERTY_ACTIONS,
    ADD_PROPERTY_NOTE,
    SELECT_CONTRACTORS,
    EDIT_PROPERTY,
    DELETE_PROPERTY,
    LOAD_PROPERTY,
    NEW_PROPERTY_CONTRACTOR,
    UPLOAD_PROPERTY_PHOTO
  } from '@/vuex/types'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'PropertyDetailsDisplay',
    components: {
      AccordianDisplay,
      DownloadInput,
      Dropdown,
      NavTabs,
      Tab,
      ResponsiveTable,
      SearchForm
    },
    computed: {
      notesForm () {
        return {
          permalink: 'getPropertyNotes',
          method: 'post',
          params: {
            accountUuid: this.$route.params.propertyUuid
          }
        }
      },
      photosForm () {
        return {
          permalink: 'getPropertyPhotos',
          method: 'post',
          params: {
            accountUuid: this.$route.params.propertyUuid
          }
        }
      },
      contractorsForm () {
        return {
          permalink: 'getPropertyContractors',
          method: 'post',
          params: {
            accountUuid: this.$route.params.propertyUuid
          }
        }
      },
      staticMap () {
        if (this.property.address) {
          let size = '400x285'
          let center = this.property.address
          center = center.replace(/\s/g, '+')
          let zoom = 17
          return `https://maps.googleapis.com/maps/api/staticmap?center=${center}&zoom=${zoom}&scale=2&size=${size}&maptype=road&markers=color:blue%7C${center}&key=AIzaSyChsNbsujgDDgecCVkJNUkG2WFntMXPZ4c`
        } else return ''
      },
      property () {
        return {
          Notes: [],
          Contractors: [],
          Attachments: [],
          ...this.loadedProperty,
          ...this.updatedProperty
        }
      },
      ...mapGetters([
        'propertyActions',
        'loadedProperty',
        'propertyNotes',
        'propertyNotesTotal',
        'propertyPhotos',
        'propertyPhotosTotal',
        'propertyContractors',
        'propertyContractorsTotal',
        'propertyContractorsColumns'
      ])
    },
    data () {
      return {
        updatedProperty: {},
        url: 'https://techcar-dev.s3.amazonaws.com/'
      }
    },
    watch: {
      $route () {
        this[LOAD_PROPERTY](this.$route.params.propertyUuid)
      }
    },
    mounted () {
      this[LOAD_PROPERTY](this.$route.params.propertyUuid)
      if (this.$route.meta.client) {
        this.$store.commit(SET_PROPERTY_ACTIONS)
      }
    },
    methods: {
      async executeAction (action, payload) {
        let result = await this[action](payload)
        if (result && result.updated) this.updatedProperty = result.updated
      },
      ...mapActions([
        ADD_PROPERTY_NOTE,
        SELECT_CONTRACTORS,
        EDIT_PROPERTY,
        DELETE_PROPERTY,
        LOAD_PROPERTY,
        NEW_PROPERTY_CONTRACTOR,
        UPLOAD_PROPERTY_PHOTO
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/PropertyDetailsDisplay.vue